import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Upload, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/Button';
const sizes = [{
  label: '22x12',
  price: 12.83
}, {
  label: '22x24',
  price: 25.67
}, {
  label: '22x36',
  price: 38.5
}, {
  label: '22x48',
  price: 51.33
}, {
  label: '22x60',
  price: 64.17
}, {
  label: '22x80',
  price: 85.56
}];
export function UploadGangSheet() {
  const [message, setMessage] = useState('');
  const [selectedSize, setSelectedSize] = useState(sizes[0].label);
  const [quantity, setQuantity] = useState(1);
  const [fileName, setFileName] = useState('');
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setFileName(file.name);
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log({
      message,
      selectedSize,
      quantity,
      fileName
    });
  };
  return <div className="min-h-screen bg-atomic-black" data-id="element-1280">
      {/* Hero Section */}
      <section className="relative py-16 md:py-20 overflow-hidden bg-gradient-to-br from-atomic-charcoal via-atomic-black to-atomic-black" data-id="element-1281">
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'linear-gradient(rgba(163, 230, 53, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(163, 230, 53, 0.1) 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }} data-id="element-1282" />

        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-1283">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="max-w-3xl mx-auto text-center" data-id="element-1284">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-1285">
              Upload{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-atomic-green to-lime-400" data-id="element-1286">
                Pre-Built Gang Sheet
              </span>
            </h1>

            <p className="text-xl text-gray-300 leading-relaxed" data-id="element-1287">
              Already have your gang sheet arranged? Upload it directly for fast
              processing and shipping.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Upload Form */}
      <section className="py-16 bg-atomic-black" data-id="element-1288">
        <div className="container mx-auto px-4 md:px-6" data-id="element-1289">
          <div className="max-w-2xl mx-auto" data-id="element-1290">
            <motion.form initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} onSubmit={handleSubmit} className="bg-atomic-charcoal rounded-xl p-8 border border-white/10" data-id="element-1291">
              {/* Message Field */}
              <div className="mb-6" data-id="element-1292">
                <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1293">
                  Add a Message
                </label>
                <textarea id="message" value={message} onChange={e => setMessage(e.target.value)} placeholder="Please enter any info about your order here" rows={4} className="w-full px-4 py-3 bg-atomic-black border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-atomic-green transition-colors resize-none" data-id="element-1294" />
              </div>

              {/* File Upload */}
              <div className="mb-6" data-id="element-1295">
                <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1296">
                  Upload Your Artwork
                </label>
                <div className="flex items-center gap-3" data-id="element-1297">
                  <label htmlFor="file-upload" className="cursor-pointer" data-id="element-1298">
                    <div className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-medium transition-colors inline-block" data-id="element-1299">
                      Choose File
                    </div>
                  </label>
                  <span className="text-gray-400 text-sm" data-id="element-1300">
                    {fileName || 'No file chosen'}
                  </span>
                  <input id="file-upload" type="file" accept="image/*" onChange={handleFileChange} className="hidden" data-id="element-1301" />
                </div>
              </div>

              {/* Size Dropdown */}
              <div className="mb-6" data-id="element-1302">
                <label htmlFor="size" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1303">
                  Choose Size
                </label>
                <select id="size" value={selectedSize} onChange={e => setSelectedSize(e.target.value)} className="w-full px-4 py-3 bg-atomic-black border border-white/10 rounded-lg text-white focus:outline-none focus:border-atomic-green transition-colors" data-id="element-1304">
                  {sizes.map(size => <option key={size.label} value={size.label} data-id="element-1305">
                      {size.label} (+${size.price.toFixed(2)})
                    </option>)}
                </select>
              </div>

              {/* Quantity */}
              <div className="mb-8" data-id="element-1306">
                <label htmlFor="quantity" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1307">
                  Quantity
                </label>
                <input id="quantity" type="number" min="1" value={quantity} onChange={e => setQuantity(parseInt(e.target.value) || 1)} className="w-32 px-4 py-3 bg-atomic-black border border-white/10 rounded-lg text-white focus:outline-none focus:border-atomic-green transition-colors" data-id="element-1308" />
              </div>

              {/* Submit Button */}
              <Button type="submit" size="lg" className="w-full md:w-auto" data-id="element-1309">
                Add To Cart
              </Button>
            </motion.form>

            {/* Need Artwork Ganged CTA - GREEN */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="mt-12 text-center" data-id="element-1310">
              <p className="text-gray-400 mb-4" data-id="element-1311">
                Need help arranging your designs into a gang sheet?
              </p>
              <a href="/dtf-printing" data-id="element-1312">
                <Button size="lg" data-id="element-1313">
                  Need Artwork Ganged? CLICK HERE
                  <ArrowRight className="ml-2 w-4 h-4" data-id="element-1314" />
                </Button>
              </a>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}